var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g, _path56, _path57, _path58, _path59, _path60, _g2, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _g3, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _g4, _path99, _path100, _path101, _path102, _path103, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginIlustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 360 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.344 113.672C34.344 113.672 12.04 171.272 43.384 229.272C74.728 287.272 139.288 317.912 190.96 344.112C242.632 370.312 296.288 357.552 321.784 314.64C347.28 271.728 312.312 241.096 312.264 179.904C312.216 118.712 321.424 102.512 288.264 50.816C255.104 -0.880044 173.816 -12.328 112.344 26.016C50.872 64.36 34.344 113.672 34.344 113.672Z",
    fill: "url(#paint0_linear_536_46323)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M301.24 48.6239L300.792 48.2159C259.536 11.0719 204.744 9.39185 164.792 49.3839C143.992 70.2239 107.04 66.2399 80.6079 73.7759C-10.4961 99.7679 5.26391 223.416 50.2799 283.2C90.9039 337.136 178.928 349.328 238.064 322.784C290.064 299.464 326.624 247.368 339.664 192.888C340.965 187.432 342.032 181.92 342.864 176.352C349.696 129.968 336.536 80.7199 301.24 48.6239Z",
    fill: "url(#paint1_linear_536_46323)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M301.24 48.6239L300.792 48.2159C259.536 11.0719 204.744 9.39185 164.792 49.3839C143.992 70.2239 107.04 66.2399 80.6079 73.7759C-10.4961 99.7679 5.26391 223.416 50.2799 283.2C90.9039 337.136 178.928 349.328 238.064 322.784C290.064 299.464 326.624 247.368 339.664 192.888C340.965 187.432 342.032 181.92 342.864 176.352C349.696 129.968 336.536 80.7199 301.24 48.6239Z",
    fill: "#1D1D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.416 101.368C33.416 101.368 35.904 92.728 52.672 92.68C69.44 92.632 79.28 107.824 79.28 107.824C79.28 107.824 86.312 101.208 94.816 105.624C103.32 110.04 103.288 116.544 103.288 116.544L173.128 122.144H21.312",
    stroke: "url(#paint2_linear_536_46323)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M350.864 158.76C350.864 158.76 348.376 150.112 331.6 150.064C314.824 150.016 305 165.216 305 165.216C305 165.216 297.968 158.6 289.464 163.016C280.96 167.432 280.992 169.936 280.992 169.936H259.152",
    stroke: "url(#paint3_linear_536_46323)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64795 154.56C7.64795 154.56 10.1359 145.92 26.9119 145.872C43.6879 145.824 53.5119 161.024 53.5119 161.024C53.5119 161.024 60.5439 154.408 69.048 158.824C77.552 163.24 77.5199 165.736 77.5199 165.736H99.36",
    stroke: "url(#paint4_linear_536_46323)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7039 221.224L40.3839 219.624C40.3839 219.624 37.0079 213.224 44.6159 205.616C52.2239 198.008 59.9359 203.08 59.9359 203.08C59.9359 203.08 67.3919 179.976 89.1519 182.688C110.912 185.4 113.2 204.392 113.2 204.392C113.2 204.392 117.848 199.728 127.32 202.792C136.792 205.856 138.224 217.584 135.88 222.52C135.88 222.52 146.664 224.416 147.384 232.744C147.384 232.744 148.048 225.376 158.2 225.152C168.352 224.928 170.88 236.352 170.88 236.352H182.28",
    stroke: "url(#paint5_linear_536_46323)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M328.04 77.04L295.016 72.992C295.016 72.992 294.048 63.536 283.896 64.008C283.896 64.008 281.656 54.832 270.736 52.056C259.816 49.28 254.12 60.8 254.12 60.8C252.197 60.3107 250.196 60.2129 248.235 60.5125C246.274 60.8121 244.393 61.503 242.704 62.544C237.472 65.84 239.56 72.144 239.56 72.144L181.96 77.92C181.96 77.92 266.576 79.848 320.36 78.048",
    stroke: "url(#paint6_linear_536_46323)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M295.056 203.136L238.152 200.576C231.896 181.648 208.232 189.56 208.232 189.56C199.272 169.936 178.4 179.288 178.4 179.288C178.4 179.288 167.76 160.368 146.776 164.328C125.792 168.288 121.48 185.032 121.48 185.032L106.992 185.584",
    stroke: "url(#paint7_linear_536_46323)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.248 188.224L9.17603 189.72",
    stroke: "url(#paint8_linear_536_46323)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M319.112 245.504C316.2 250.736 313.056 255.856 309.696 260.816C308.176 263.072 306.608 265.28 305.008 267.464C302.144 271.331 299.144 275.085 296.008 278.728C295.011 279.901 293.989 281.061 292.944 282.208C290.565 284.843 288.117 287.397 285.6 289.872L284.192 291.248C270.752 304.337 255.149 315.001 238.072 322.768C206.472 336.96 166.608 340.08 130.144 331.672C128.008 331.176 125.88 330.648 123.744 330.072C122.192 329.645 120.648 329.203 119.112 328.744C117.459 328.248 115.813 327.715 114.176 327.144C113.376 326.88 112.576 326.6 111.776 326.344C108.232 325.096 104.736 323.72 101.32 322.232L100.184 321.728C88.579 316.626 77.7458 309.923 68 301.816",
    stroke: "#2F2F2F",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M291.816 217.352C291.816 217.352 304.92 221.784 303.016 231.792C302.984 231.792 287.872 234.6 291.816 217.352Z",
    fill: "#2F2F2F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M317.648 226.488C317.648 226.488 327.664 218.272 338.448 226.488C338.4 226.504 328 236.848 317.648 226.488Z",
    fill: "#2F2F2F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M344.224 199.28C344.224 199.28 341.456 219.28 325.128 209.432C325.128 209.432 334.352 196.568 344.224 199.28Z",
    fill: "#2F2F2F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M325.24 182.976C325.24 182.976 337.32 194.056 324.144 202.904C324.144 202.904 316.4 192.248 325.24 182.976Z",
    fill: "#2F2F2F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M303.648 196C303.648 196 319.24 198.304 315.648 212.384C315.68 212.376 300.32 209.128 303.648 196Z",
    fill: "#2F2F2F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M303.776 247.472C303.776 247.472 301.104 237.216 311.504 224.08C321.904 210.944 327.312 199.032 326.056 189.36",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M307.68 201.04C307.68 201.04 315.88 206.96 316.608 217.136",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M337.448 205.84C337.448 205.84 330.368 211.688 321.64 208.656",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M332.072 227.096C332.072 227.096 316.424 227.608 310.976 224.768",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M295.056 222.896C295.056 222.896 299.48 231.376 306.064 232.92",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M325.344 199.008C326.179 195.864 326.421 192.592 326.056 189.36",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M307.68 201.04C310.851 203.499 313.349 206.718 314.944 210.4",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M337.448 205.84C334.928 207.765 331.945 208.99 328.8 209.392",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M332.072 227.096C328.23 227.209 324.384 227.11 320.552 226.8",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M295.056 222.896C296.546 225.599 298.48 228.033 300.776 230.096",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8561 272.704C89.8561 272.704 77.5681 279.056 80.9921 288.656C80.9921 288.656 96.3521 289.16 89.8561 272.704Z",
    fill: "#2F2F2F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6961 285.6C65.6961 285.6 54.5521 279.008 45.1521 288.8C45.1521 288.8 57.0481 297.416 65.6961 285.6Z",
    fill: "#2F2F2F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3281 262.728C35.3281 262.728 41.0641 282.056 55.7361 269.888C55.7361 269.888 44.6801 258.56 35.3281 262.728Z",
    fill: "#2F2F2F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M51.64 243.752C51.64 243.752 41.368 256.552 55.72 263.28C55.72 263.28 61.776 251.584 51.64 243.752Z",
    fill: "#2F2F2F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9441 253.36C74.9441 253.36 59.8801 257.992 65.5121 271.376C65.5121 271.376 80.2081 265.856 74.9441 253.36Z",
    fill: "#2F2F2F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7042 305.496C82.7042 305.496 83.6642 293.736 71.4082 282.296C59.1522 270.856 52.0082 259.896 51.7922 250.168",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M71.712 258.96C71.712 258.96 64.512 266.056 65.312 276.216",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0081 268.192C43.0081 268.192 50.8881 272.904 59.0641 268.592",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M51.52 288.392C51.52 288.392 67.072 286.544 72.032 282.92",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4881 278.672C87.4881 278.672 84.4641 287.976 78.1841 290.496",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9522 259.608C52.6549 256.627 51.9225 253.432 51.7922 250.184",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7121 258.96C68.9487 261.873 66.9649 265.436 65.9441 269.32",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0081 268.192C45.7801 269.711 48.9038 270.473 52.0641 270.4",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M51.52 288.392C55.3357 287.941 59.1231 287.276 62.864 286.4",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4884 278.672C86.4289 281.578 84.8843 284.283 82.9204 286.672",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M267.928 271.2C277.664 276.08 282.264 285.744 284.184 291.248L285.592 289.872C288.109 287.392 290.557 284.837 292.936 282.208C293.976 281.067 294.997 279.907 296 278.728C296.464 276.872 296.992 274.912 297.6 272.888C298.112 271.136 298.68 269.336 299.296 267.512C299.96 265.536 300.68 263.512 301.472 261.544C302.152 259.824 302.88 258.104 303.664 256.416C304.448 254.728 305.144 253.024 305.672 251.536C307.88 245.288 307.736 241.368 306.568 239.376C305.24 237.12 302.608 237.312 300.584 239.376C300.14 239.843 299.738 240.349 299.384 240.888C297.661 243.689 296.224 246.655 295.096 249.744C293.024 255.016 291.512 260.144 291.512 260.144C291.512 260.144 293.872 242.88 293.208 233.648C292.736 227.168 292.048 221.36 290.808 217.24C289.424 212.768 287.344 210.288 284.088 211.096C279.544 212.224 281.736 223.096 283.176 237.8C283.68 242.912 284.088 248.496 284.088 254.296C284.103 258.343 283.881 262.387 283.424 266.408C283.424 266.408 283.176 266 282.752 265.264C280.584 261.496 273.704 249.064 271.096 238.24C267.984 225.312 259.336 230.736 262.104 242.312C264.872 253.888 276.28 260.52 280.504 273.096C280.504 273.096 265.912 259.104 261.08 264.424C258.312 267.432 265.024 269.752 267.928 271.2Z",
    fill: "#59D9C6",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M267.928 271.2C277.664 276.08 282.264 285.744 284.184 291.248L285.592 289.872C288.109 287.392 290.557 284.837 292.936 282.208C293.976 281.067 294.997 279.907 296 278.728C296.464 276.872 296.992 274.912 297.6 272.888C298.112 271.136 298.68 269.336 299.296 267.512C299.96 265.536 300.68 263.512 301.472 261.544C302.152 259.824 302.88 258.104 303.664 256.416C304.448 254.728 305.144 253.024 305.672 251.536C307.88 245.288 307.736 241.368 306.568 239.376C305.24 237.12 302.608 237.312 300.584 239.376C300.14 239.843 299.738 240.349 299.384 240.888C297.661 243.689 296.224 246.655 295.096 249.744C293.024 255.016 291.512 260.144 291.512 260.144C291.512 260.144 293.872 242.88 293.208 233.648C292.736 227.168 292.048 221.36 290.808 217.24C289.424 212.768 287.344 210.288 284.088 211.096C279.544 212.224 281.736 223.096 283.176 237.8C283.68 242.912 284.088 248.496 284.088 254.296C284.103 258.343 283.881 262.387 283.424 266.408C283.424 266.408 283.176 266 282.752 265.264C280.584 261.496 273.704 249.064 271.096 238.24C267.984 225.312 259.336 230.736 262.104 242.312C264.872 253.888 276.28 260.52 280.504 273.096C280.504 273.096 265.912 259.104 261.08 264.424C258.312 267.432 265.024 269.752 267.928 271.2Z",
    fill: "#2F2F2F",
    stroke: "#2F2F2F",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M278.4 250.64C280.329 255.355 281.759 260.259 282.664 265.272C284.14 273.303 284.677 281.477 284.264 289.632L285.536 289.88C288.053 287.4 290.501 284.845 292.88 282.216C293.92 281.075 294.941 279.915 295.944 278.736C299.08 275.099 302.08 271.344 304.944 267.472C306.544 265.288 308.144 263.08 309.632 260.824C305.744 262.48 301.536 265.624 299.232 267.528C298.12 268.424 297.44 269.032 297.44 269.032C298.467 266.389 299.81 263.88 301.44 261.56C306.904 253.56 314.496 247.848 316.968 238.92C320.168 227.448 311.704 221.72 308.128 234.536C307.68 236.136 307.136 237.736 306.528 239.392C302.264 250.832 294.792 262.248 294.792 262.248C296.864 255.266 298.384 248.132 299.336 240.912C301.736 223.784 301.264 207.04 296.136 206.952C292.192 206.88 290.8 210.512 290.76 217.264C290.791 221.172 291.026 225.076 291.464 228.96C292.872 243.112 288.856 263.48 288.856 263.48C288.856 263.48 286.592 244.664 283.128 237.824C282.833 237.214 282.462 236.644 282.024 236.128C277.944 231.64 270.984 232.888 278.4 250.64Z",
    fill: "#59D9C6",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M282.4 249.824C288.72 264.808 288.712 286.496 288.712 286.496C288.712 286.496 298.152 243.576 296.296 225.384",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M311.008 241.792C311.008 241.792 300.976 262.032 291.984 269.704",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M289.96 280.392C291.4 278.16 294.352 275.464 297.584 272.896C300.08 270.92 302.736 269.016 305 267.472",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0081 315.2C95.0748 316.352 96.3201 317.573 97.7441 318.864C98.9601 319.952 100.144 321.088 101.304 322.24C104.72 323.728 108.216 325.104 111.76 326.352C112.56 326.632 113.36 326.912 114.16 327.152C115.792 327.685 117.437 328.219 119.096 328.752C120.632 329.216 122.176 329.659 123.728 330.08C125.84 330.656 127.968 331.184 130.128 331.68C131.102 326.801 133.267 322.239 136.432 318.4C138.528 315.92 143.784 311.144 140.104 309.456C133.568 306.464 125.704 325.072 125.704 325.072C124.64 311.848 132.52 301.256 130.504 289.528C128.488 277.8 118.408 276.216 120.64 289.328C122.504 300.304 121.072 314.44 120.56 318.76C120.464 319.6 120.392 320.072 120.392 320.072C118.394 316.56 116.602 312.936 115.024 309.216C112.736 303.888 110.92 298.592 109.368 293.696C104.896 279.6 102.64 268.752 98.0161 269.504C94.7041 270.048 93.7681 273.144 94.2561 277.8C94.7121 282.088 96.3601 287.696 98.4801 293.8C101.456 302.408 110.192 317 110.48 317.48C110.272 317.232 106.952 313.248 103.104 309.344C100.848 306.953 98.358 304.792 95.6721 302.896C95.1332 302.543 94.5659 302.235 93.9761 301.976C91.2961 300.88 88.8081 301.736 88.4721 304.336C88.1121 306.632 89.5201 310.296 94.0081 315.2Z",
    fill: "#59D9C6",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M94.0081 315.2C95.0748 316.352 96.3201 317.573 97.7441 318.864C98.9601 319.952 100.144 321.088 101.304 322.24C104.72 323.728 108.216 325.104 111.76 326.352C112.56 326.632 113.36 326.912 114.16 327.152C115.792 327.685 117.437 328.219 119.096 328.752C120.632 329.216 122.176 329.659 123.728 330.08C125.84 330.656 127.968 331.184 130.128 331.68C131.102 326.801 133.267 322.239 136.432 318.4C138.528 315.92 143.784 311.144 140.104 309.456C133.568 306.464 125.704 325.072 125.704 325.072C124.64 311.848 132.52 301.256 130.504 289.528C128.488 277.8 118.408 276.216 120.64 289.328C122.504 300.304 121.072 314.44 120.56 318.76C120.464 319.6 120.392 320.072 120.392 320.072C118.394 316.56 116.602 312.936 115.024 309.216C112.736 303.888 110.92 298.592 109.368 293.696C104.896 279.6 102.64 268.752 98.0161 269.504C94.7041 270.048 93.7681 273.144 94.2561 277.8C94.7121 282.088 96.3601 287.696 98.4801 293.8C101.456 302.408 110.192 317 110.48 317.48C110.272 317.232 106.952 313.248 103.104 309.344C100.848 306.953 98.358 304.792 95.6721 302.896C95.1332 302.543 94.5659 302.235 93.9761 301.976C91.2961 300.88 88.8081 301.736 88.4721 304.336C88.1121 306.632 89.5201 310.296 94.0081 315.2Z",
    fill: "#2F2F2F",
    stroke: "#2F2F2F",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6241 308C84.0321 314.76 92.4641 317.208 100.224 321.72L101.36 322.224C104.776 323.712 108.272 325.088 111.816 326.336C112.616 326.616 113.416 326.896 114.216 327.136C115.848 327.669 117.493 328.203 119.152 328.736C120.688 329.2 122.232 329.643 123.784 330.064C122.503 326.352 121.435 322.57 120.584 318.736C119.443 313.769 118.826 308.696 118.744 303.6C118.6 284.352 111.712 285.944 109.728 291.656C109.534 292.306 109.418 292.978 109.384 293.656C108.896 301.192 114.056 318.952 114.184 319.48C113.824 318.96 102.416 302.144 98.1841 288.784C97.0435 285.042 95.7083 281.363 94.1841 277.76C91.4881 271.568 88.7841 268.776 85.1841 270.4C80.4641 272.512 86.6641 288.072 95.5841 302.888C99.3014 309.146 103.504 315.103 108.152 320.704C107.808 320.472 96.6721 313.024 88.3761 304.32C87.1841 303.056 86.0401 301.776 85.0001 300.48C76.6881 290.136 71.2001 298.728 78.6241 308Z",
    fill: "#59D9C6",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M114.192 327.2C114.04 326.968 113.888 326.736 113.728 326.504C110.368 321.384 106.528 315.384 103.04 309.384C98.3522 301.384 94.1922 293.384 92.3442 287.448",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M114.736 304.424C114.736 306.024 114.832 307.624 114.976 309.224C115.708 315.86 117.096 322.406 119.12 328.768",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M85.248 308.312C85.248 308.312 102.448 322.968 113.728 326.48",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M111.792 326.352C152.728 340.832 201.056 339.392 238.064 322.776C259.04 313.368 277.512 299.272 292.936 282.216L279.2 268.04H264L257.272 246.504C257.272 246.504 150.224 244.96 140.472 245.544C130.72 246.128 123.416 259.944 123.416 259.944L135.256 278.776L119.576 302.04L111.792 326.352Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_536_46323",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 245,
    width: 182,
    height: 92
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M111.792 326.352C152.728 340.832 201.056 339.392 238.064 322.776C259.04 313.368 277.512 299.272 292.936 282.216L279.2 268.04H264L257.272 246.504C257.272 246.504 150.224 244.96 140.472 245.544C130.72 246.128 123.416 259.944 123.416 259.944L135.256 278.776L119.576 302.04L111.792 326.352Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_536_46323)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M151.496 254.896C166.176 257.112 189.552 251.104 189.552 251.104C202.252 254.552 215.442 255.834 228.568 254.896C242.896 253.856 249.44 249.368 252.232 246.432C230.912 246.136 148.952 245.04 140.456 245.544C139.643 245.594 138.838 245.736 138.056 245.968L144.872 248.016C144.872 248.016 136.8 252.68 151.496 254.896Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M264 268.04C264 268.04 238.12 281.104 237.464 280.392C236.808 279.68 220.144 274.232 220.144 274.232L209.6 277.544L220.176 264.136L248.376 263.28L257.304 246.48L264 268.04Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M119 303.816L135.24 313.84L167.712 303.272L135.24 278.8L119.56 302.064L119 303.816Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M142.096 334.008C175.144 339.28 209.888 335.424 238.096 322.808C259.072 313.4 277.544 299.304 292.968 282.248L279.2 268.04L265.912 296.84H226.288L199.272 320.32L162.552 322.032L142.096 334.008Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.152 280.68L179.424 283.432L163.072 276.216L159.696 264.144L136.808 261.808L123.4 259.968",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.152 264.144L248.352 263.28L257.28 246.504",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.288 296.856L199.272 320.32L179.848 313.84L181.952 300.296L173.288 300.56",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.68 303.616L135.24 313.84L136.808 322.032",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M111.792 326.352C152.728 340.832 201.056 339.392 238.064 322.776C259.04 313.368 277.512 299.272 292.936 282.216L279.2 268.04H264L257.272 246.504C257.272 246.504 150.224 244.96 140.472 245.544C130.72 246.128 123.416 259.944 123.416 259.944L135.256 278.776L119.576 302.04L111.792 326.352Z",
    stroke: "#2F2F2F",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M253.272 219.128C255.312 237.696 249.896 246.56 239.6 250.568C228.4 254.92 212.016 253.688 198.968 250.104C196.568 249.432 155.168 234.528 148.624 223.56C143.2 214.456 142.488 205.528 154.112 204.904C159.656 204.608 208.968 217.864 208.968 217.864L213.608 216.176L253.272 219.128Z",
    fill: "#1D1D1D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M225.36 131.2C225.767 131.67 226.082 132.213 226.288 132.8C226.839 134.487 227.157 136.242 227.232 138.016C227.341 139.857 227.341 141.703 227.232 143.544L240.576 143.04C239.224 135.992 243.592 130.4 243.592 130.4C243.904 108.248 222.832 128.424 225.36 131.2Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M239.6 139.48C239.6 139.48 218.92 140.392 214.048 155.48C214.048 155.48 204.744 160.72 207.592 168.944C210.44 177.168 212.968 186.16 212.968 186.16C212.968 186.16 211.288 198.064 211.92 204.184C211.92 204.184 208.72 212.008 210.32 213.68C210.32 213.68 206.784 216.488 207.12 217.264C209.48 223.152 245.656 229.632 254.616 223.064C257.344 221.064 244.04 187.32 245.32 185.616C246.6 183.912 251.968 168.632 251.336 166.096C251.336 166.096 257.344 167.96 257.344 155.48C257.344 143 248.592 137.8 239.6 139.48Z",
    fill: "#DBC958"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_536_46323",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 207,
    y: 139,
    width: 51,
    height: 87
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M239.6 139.48C239.6 139.48 218.92 140.392 214.048 155.48C214.048 155.48 204.744 160.72 207.592 168.944C210.44 177.168 212.968 186.16 212.968 186.16C212.968 186.16 211.288 198.064 211.92 204.184C211.92 204.184 208.72 212.008 210.32 213.68C210.32 213.68 206.784 216.488 207.12 217.264C209.48 223.152 245.656 229.632 254.616 223.064C257.344 221.064 244.04 187.32 245.32 185.616C246.6 183.912 251.968 168.632 251.336 166.096C251.336 166.096 257.344 167.96 257.344 155.48C257.344 143 248.592 137.8 239.6 139.48Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_536_46323)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257.28 155.448C257.28 167.928 251.272 166.064 251.272 166.064C251.448 166.768 251.16 168.464 250.632 170.552C250.301 170.365 249.98 170.159 249.672 169.936C241.392 164 243.2 147.024 224.32 147.76C224.32 147.76 231.184 142.808 237.472 144.56C243.76 146.312 249.064 152.496 250.928 152.408C252.792 152.32 249.88 149.664 249.672 148.296C249.504 147.24 253.44 149.56 256.664 150.136C257.086 151.875 257.293 153.659 257.28 155.448Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233 180C233 180 231.176 201.504 210.952 206.88C211.44 205.336 211.92 204.152 211.92 204.152C211.288 198.032 212.968 186.128 212.968 186.128C212.968 186.128 210.448 177.144 207.592 168.912C207.544 168.776 207.504 168.64 207.464 168.504C210.229 167.748 212.66 166.086 214.368 163.784C218.752 158.048 233 180 233 180Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M224.32 218.856C218.888 219.535 213.385 219.381 208 218.4C207.609 218.081 207.297 217.675 207.088 217.216C206.8 216.496 209.808 214.016 210.288 213.672C214.064 215.472 220.464 218.256 224.32 218.856Z",
    fill: "#1D1D1D"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M239.6 139.48C239.6 139.48 218.92 140.392 214.048 155.48C214.048 155.48 204.744 160.72 207.592 168.944C210.44 177.168 212.968 186.16 212.968 186.16C212.968 186.16 211.288 198.064 211.92 204.184C211.92 204.184 208.72 212.008 210.32 213.68C210.32 213.68 206.784 216.488 207.12 217.264C209.48 223.152 245.656 229.632 254.616 223.064C257.344 221.064 244.04 187.32 245.32 185.616C246.6 183.912 251.968 168.632 251.336 166.096C251.336 166.096 257.344 167.96 257.344 155.48C257.344 143 248.592 137.8 239.6 139.48Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M251.272 166.064C247.16 164.696 247.272 150.984 239.6 147.608C231.928 144.232 221.544 147.816 218.632 151.192",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M160.864 201.192L148.576 202.872L144.72 206.072L143.392 210.928C143.392 210.928 145.144 210.4 146.424 207.392C146.424 207.392 147.928 206.464 149.44 205.416C151.701 206.2 154.09 206.548 156.48 206.44C159.232 206.44 159.888 209.368 163.44 208.464C169.76 206.816 160.864 201.192 160.864 201.192Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M229.536 152.728C220.2 149.352 210.232 171.928 200.736 184.32C199.368 186.112 172.888 195.712 164.024 198.872L158.328 200.56C158.328 200.56 161.704 208.368 166.56 210.904L170.992 209.632C170.992 209.632 211.704 201.552 216.44 198.48C218.84 196.88 239.64 175.88 239.6 169.336",
    fill: "#DBC958"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M229.536 152.728C220.2 149.352 210.232 171.928 200.736 184.32C199.368 186.112 172.888 195.712 164.024 198.872L158.328 200.56C158.328 200.56 161.704 208.368 166.56 210.904L170.992 209.632C170.992 209.632 211.704 201.552 216.44 198.48C218.84 196.88 239.64 175.88 239.6 169.336",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M183.424 246.816C185.88 239.368 177.256 236.416 172.8 237.488C168.344 238.56 162.264 236.544 157.6 237.248C152.936 237.952 148.088 238.16 149.352 245.544C150.616 252.928 180.8 254.832 183.424 246.816Z",
    fill: "#424242",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M167.08 238.584L166.504 240.184C166.504 240.184 161 238.496 157.6 239.384C154.2 240.272 152.624 240.072 152.208 241.44C151.792 242.808 151.04 245.552 152.208 245.976C153.376 246.4 163.072 249.176 165.184 248.928L166.024 251.144",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M162.048 248.536V250.296",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M158.144 247.632L157.6 249.416",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M153.952 246.504L153.152 248.528",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M151.584 244.56L149.992 244.864",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M152.208 241.432L150.784 240.592",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M154.584 240.048L153.952 238.584",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M158.64 238.584V237.744",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M162.552 239.312L163.072 237.744",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M172.8 238.528L173.432 240.592C173.432 240.592 175.832 238.656 178.28 240.048C180.728 241.44 180.816 243.544 179.88 245.968C178.944 248.392 174.4 248.528 174.4 248.528L173.768 250.296",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M177.84 249.416L177.224 248.016",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M181.952 246.504L179.84 245.968",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M181.952 241.688L180.152 242.072",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M177.528 238.584L177.224 239.576",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M167.712 241.688C167.712 241.688 165.816 244.016 167.08 248.016",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M172.8 242.072C172.8 242.072 173.96 245.68 172.8 247.512",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M171.824 240.592C170.771 240.742 169.697 240.551 168.76 240.048",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M172.248 250.296C171.115 249.925 169.893 249.925 168.76 250.296",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M163.072 241.432C162.885 243.116 162.8 244.81 162.816 246.504",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M158.64 241.008C158.347 242.503 158.181 244.021 158.144 245.544",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M154.584 241.432C154.584 241.432 154.12 243.832 153.952 244.712",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M176.584 241.688C176.584 241.688 176.52 243.76 176.584 245.968",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.896 225.792C222.896 225.792 218.896 227.512 219.52 229.12C220.144 230.728 221.168 233.056 221.168 233.056C221.168 233.056 211.224 237.344 207.032 237.096C202.84 236.848 188.288 231.448 188.288 231.448V224.616L183.856 221.872C183.856 221.872 181.248 230.944 181.496 234.528L185.544 237.728L187.232 233.672",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.6 226.832C229.6 226.832 224.112 234.584 222.904 235.376C221.696 236.168 211.56 239.144 207.92 239.08C204.28 239.016 189.568 234.28 189.568 234.28",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.952 222.56C181.952 222.08 173.288 219.552 173.288 219.552C173.324 222.486 172.975 225.413 172.248 228.256L171.04 233C171.04 233 179.176 237.104 181.952 237.096",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.296 224.456C170.296 224.456 150.208 215.912 149.152 215.44C148.24 215.179 147.273 215.179 146.36 215.44",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.248 228.256C172.248 228.256 162.04 224.512 158.392 221.856C154.744 219.2 147.144 217.48 147.144 217.48",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.6 232.208C241.6 232.208 247.616 232.368 249.832 231.408L251.256 237.088C251.256 237.088 247.144 238.984 245.08 238.52C243.016 238.056 241.6 235 241.6 235",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.352 236.328C240.352 236.328 237.032 244.008 233.072 245.544C233.072 245.544 237.184 248.136 243.52 246.504C243.52 246.504 248.992 242.048 249.672 237.744",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M226.288 132.8C226.839 134.487 227.157 136.242 227.232 138.016C231.648 135.256 230.776 132.8 230.776 132.8H226.288Z",
    fill: "#1D1D1D"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M242.904 130.952C259.296 112.352 247.048 102.296 237.232 101.528C215.2 99.816 222.4 118.112 221.136 119.2C219.056 120.984 217.04 121.6 216.968 122.52C216.864 123.896 219.096 125.632 219.096 125.632L218.296 128.584L219.048 128.888C219.048 128.888 219.28 136.744 221.264 136.744C227.192 136.744 230.72 134.832 231.48 133.016",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M242.904 130.952C259.296 112.352 247.048 102.296 237.232 101.528C215.2 99.816 222.4 118.112 221.136 119.2C219.056 120.984 217.04 121.6 216.968 122.52C216.864 123.896 219.096 125.632 219.096 125.632L218.296 128.584L219.048 128.888C219.048 128.888 219.28 136.744 221.264 136.744C227.192 136.744 230.72 134.832 231.48 133.016",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M222.52 112.224C223.359 112.285 224.16 112.598 224.818 113.122C225.476 113.646 225.96 114.356 226.208 115.16",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M222.76 118.64C222.696 119.44 222.92 120.088 223.248 120.112C223.576 120.136 223.904 119.52 223.968 118.736C224.032 117.952 223.808 117.296 223.472 117.272C223.136 117.248 222.816 117.856 222.76 118.64Z",
    fill: "#1D1D1D"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M219.04 128.888C219.04 128.888 220.864 129.032 221.256 128.272",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M228.544 99.7679C228.544 99.7679 223.04 99.7679 219.976 103.768C219.101 104.936 218.576 106.328 218.461 107.782C218.346 109.236 218.647 110.694 219.328 111.984L220.568 109.528C220.568 109.528 222.448 112.672 227.528 112.632L226.728 108.952C226.728 108.952 228.584 113.048 232.08 114.312L231.576 120.784C231.576 120.784 234.032 118.12 236.576 119.696C241.376 122.656 239.776 130.528 239.776 130.528C239.776 130.528 243.968 133 247.712 131.16C251.456 129.32 261.96 116.808 253.152 105.104C244.344 93.3999 229.904 98.6079 228.544 99.7679Z",
    fill: "#1D1D1D"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M233.888 119.52C233.888 119.52 238.528 115.408 239.968 118.576C241.408 121.744 239.464 124.976 237.192 126.904C234.92 128.832 230.456 129.128 232.392 126.528",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M233.888 119.52C233.888 119.52 238.528 115.408 239.968 118.576C241.408 121.744 239.464 124.976 237.192 126.904C234.92 128.832 230.456 129.128 232.392 126.528",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M253.008 111.624C253.008 111.624 257.248 100.424 267.816 102.024C275.072 103.128 269.784 106.376 269.784 106.376C269.784 106.376 277.584 107.632 279.456 113.688C280.4 116.736 274.464 114.104 274.464 114.104C274.464 114.104 276.936 116.376 277.664 121.184C278.168 124.384 274.56 124.032 269.032 118.416C269.032 118.416 269.64 120.736 273.088 123.216C276.536 125.696 267.624 126.984 263.016 121.048C263.084 121.73 262.985 122.419 262.727 123.055C262.469 123.69 262.06 124.254 261.536 124.696C259.752 126.104 260.928 120.048 255.456 118.016C249.984 115.984 253.008 111.624 253.008 111.624Z",
    fill: "#1D1D1D"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.288 101.864C226.288 101.864 221.384 103.824 222.52 108.152",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.536 102.608C227.536 102.608 227.056 108.304 233.232 110.52",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.896 101.416C231.896 101.416 247.032 98.2159 253.496 110.52",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.952 114.72C234.952 114.72 245.888 118.72 254.152 114.72",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2 127.296C243.2 127.296 250.048 124.328 253.504 118.688",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.28 110.52C257.28 110.52 264.792 105.368 270.736 111.472",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.864 113.688C258.864 113.688 265.208 113.408 265.872 118.688",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M210.28 213.648C210.28 213.648 223.88 221.872 240.464 219.552",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M239.6 176.512C239.6 176.512 235.848 182.976 230.848 183.536",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M245.256 185.6C245.256 185.6 240.872 191.088 237.472 190.872",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M162.552 199.312C163.691 202.689 165.88 205.613 168.8 207.656",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M200.736 184.32C200.736 184.32 206.648 187.4 211.288 183.52",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_536_46323",
    x1: 26.6504,
    y1: 3.29248,
    x2: 376.989,
    y2: 304.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_536_46323",
    x1: 14.2512,
    y1: 19.8735,
    x2: 330.392,
    y2: 349.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_536_46323",
    x1: 21.312,
    y1: 92.6799,
    x2: 32.3335,
    y2: 149.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_536_46323",
    x1: 259.152,
    y1: 150.064,
    x2: 267.377,
    y2: 188.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_536_46323",
    x1: 7.64795,
    y1: 145.872,
    x2: 15.8672,
    y2: 183.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_536_46323",
    x1: 16.7039,
    y1: 182.467,
    x2: 48.418,
    y2: 279.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_536_46323",
    x1: 181.96,
    y1: 51.6243,
    x2: 191.744,
    y2: 104.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_536_46323",
    x1: 106.992,
    y1: 163.783,
    x2: 122.771,
    y2: 239.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_536_46323",
    x1: 9.17603,
    y1: 188.224,
    x2: 9.25579,
    y2: 191.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIlustration);
export default __webpack_public_path__ + "static/media/login-ilustration.d62644483856eb18dc61e3c986ccbe87.svg";
export { ForwardRef as ReactComponent };